export default "__VITE_ASSET__Dk3b_KhL__"